import ClientTemplate from '@/models/client/client-template'
import { IClientState } from './interfaces/client-state'

export default class ClientState implements IClientState {
  public clientTemplate: ClientTemplate = new ClientTemplate()
  public isPreviewMode = false
}
